<template>
  <div class="icon-service-ui">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 130 130"
      xmlns="http://www.w3.org/2000/svg"
    >

      <g
        transform="translate(-612 -34)"
        stroke="#FFF"
        stroke-width="2"
        fill="none"
        fill-rule="evenodd"
      >

        <ellipse
          cx="677"
          cy="98"
          rx="55"
          ry="55"
          stroke-dasharray="345.02 345.02"
          stroke-dashoffset="345.02"
        />
        <!-- eslint-disable max-len -->
        <path
          d="M696.792 101.81c-1.696 0-2.645.466-3.74 1.558v-2.842c0-3.306-3.277-5.838-6.592-5.838-1.746 0-3.202.386-4.302 1.575-.49-2.818-3.067-4.605-6.03-4.605-1.695 0-3.297.635-4.391 1.763V80.228c-.001-3.306-2.842-6.228-6.158-6.228-3.316 0-6.158 2.922-6.158 6.228v30.72c-5.717.006-9.668 5.645-9.668 12.777v1.38c0 6.74 1.913 18.924 14.72 24.77 3.22 1.47 6.764 1.69 10.194 1.903 1.265.079 2.63.138 4.057.138 3.97 0 8.426-.46 12.563-2.254 7.312-3.168 11.617-10.573 11.517-19.798v-22.252c0-3.2-2.697-5.802-6.012-5.802zM682.158 108.579V95.316M693.053 111.421V101M671.737 106.684V90.58M659.421 120.895v-16.106"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="286.76 286.76"
          stroke-dashoffset="286.76"
        />

        <path
          d="M658.646 103.286H642.33c-2.944 0-4.331-1.798-4.331-4.003V59M716 59v40.283c0 2.21-1.377 4.003-4.33 4.003h-11.148M671.774 86.805A11.677 11.677 0 0 0 678 76.475c0-6.45-5.229-11.679-11.679-11.679s-11.678 5.229-11.678 11.679a11.66 11.66 0 0 0 4.57 9.266"
          stroke-dasharray="181.44 181.44"
          stroke-dashoffset="181.44"
        />

        <!-- eslint-enable max-len -->

      </g>

    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconServiceUi'
};
</script>

<style lang="scss" src="@/assets/icons/icon-service-ui-view.scss"></style>



// WEBPACK FOOTER //
// icon-service-ui-view.vue